module.exports = __webpack_public_path__ + "img/logo-4.ed076ed1.png";